<template>
  <div>
    <b-button v-b-modal.reportModal variant="primary">
      {{ $t('reports.downloadSensorValues') }}
    </b-button>
    <b-modal
      id="reportModal"
      v-model="protocolModal"
      centered
      hide-footer
      hide-header
      size="md"
      :body-class="isMobile ? 'bg-third p-5' : 'bg-third p-3'"
      @hide="onClose"
      @show="downloadReport"
    >
      <div class="d-flex justify-content-between align-items-center pb-4">
        <h3>{{ $t('reports.download') }}</h3>
        <b-button variant="transparent" class="p-0" @click="onClose()">
          <i class="mdi mdi-close text-muted" style="font-size: 22px"></i>
        </b-button>
      </div>
      <div v-if="processing">
        <b-row align-v="center" class="text-center minHeight">
          <b-col>
            <h5 class="text-center mb-5">{{ $t('reports.processing') }}</h5>
            <b-spinner type="grow" class="text-primary m-1"></b-spinner>
            <b-spinner type="grow" class="text-primary m-1"></b-spinner>
            <b-spinner type="grow" class="text-primary m-1"></b-spinner>
          </b-col>
        </b-row>
      </div>
      <div v-else-if="protocolUrl">
        <b-row align-v="center" class="text-center minHeight">
          <b-col>
            <h5 class="text-center mb-5">{{ $t('reports.reportReady') }}</h5>
            <i class="mdi mdi-check text-primary" style="font-size: 40px"></i>
          </b-col>
        </b-row>
      </div>
      <div
        v-if="(processing || protocolUrl) && !processingAcces"
        class="d-flex justify-content-between align-items-center"
      >
        <b-button class="px-4 btn-block" variant="transparent" size="lg" @click="onClose()">
          {{ $t('button.cancel.label') }}
        </b-button>
        <b-button
          :href="protocolUrl"
          class="px-4 btn-block mt-0"
          :variant="processing ? 'secondarygray' : 'primary'"
          size="lg"
          :disabled="processing"
          @click="onClose()"
        >
          {{ $t('button.getEfficiencyProtocol.download') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import sensorValuesReport from '@/api/boxinfo/mutations/sensorValuesReport.gql';
import { vueWindowSizeMixin } from 'vue-window-size';

export default {
  name: 'SensorValuesReportForm',
  mixins: [vueWindowSizeMixin],
  props: {
    sensorId: Number,
    period: Object,
  },
  data() {
    return {
      protocolModal: false,
      protocolUrl: '',
      processingAcces: true,
      processing: false,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth > 700;
    },
    locale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    onClose() {
      this.processing = false;
      this.processingAcces = true;
      this.protocolUrl = '';
      this.protocolModal = false;
    },
    downloadReport() {
      this.processingAcces = false;
      this.processing = true;
      const vm = this;

      this.$apollo
        .mutate({
          mutation: sensorValuesReport,
          variables: {
            reportParams: {
              sensorId: this.sensorId,
              dateStart: this.period.dateStart,
              dateEnd: this.period.dateEnd,
            },
          },
        })
        .then((result) => {
          vm.processing = false;
          const data = ((result.data || {}).koeeBoxMutation || {}).sensorValuesReport || {};
          if (data && data.success && data.file) {
            vm.protocolUrl = data.file;
          } else {
            const message = (data || {}).errorMessage || vm.$t('box.report.error');
            vm.$bvToast.toast(message, {
              title: vm.$t('box.report.error'),
              variant: 'danger',
              solid: true,
            });
          }
        })
        .catch((e) => {
          vm.onClose();
          vm.$bvToast.toast(vm.$t('box.report.error'), {
            title: vm.$t('box.report.error'),
            variant: 'danger',
            solid: true,
          });
          console.log(e);
        });
    },
  },
};
</script>
